import { Button } from '@pwc/pwc-deals-ui';
import React from 'react';
import { postPowerpointGroup } from '../../libraryItemService';
import { useIngestionErrors } from './IngestionErrorProvider';
import {
  ErrorAction,
  ErrorActionType,
} from './PowerPointIngestionErrorHandling';

const formIsValid = (fileName, slideNumber, groupName) => {
  return fileName && slideNumber.trim() && groupName.trim();
};

export const PowerPointIngestButton = ({
  driveItemId,
  driveId,
  fileName,
  slideNumber,
  groupName,
  loading,
  handleSuccessfulIngestion,
  projectId,
  sharePointItemUrl,
  setIsLoading,
  setSlideNumber,
  setGroupName,
}) => {
  const [, errorDispatch] = useIngestionErrors();

  const clearFields = () => {
    setSlideNumber('');
    setGroupName('');
  };

  const handleIngest = async () => {
    try {
      setIsLoading(true);
      errorDispatch({
        type: ErrorActionType.INGESTION_ERROR,
        value: '',
      });
      await postPowerpointGroup(
        projectId,
        sharePointItemUrl,
        driveItemId,
        fileName,
        groupName,
        slideNumber,
        driveId
      );
      clearFields();
      handleSuccessfulIngestion();
    } catch (e) {
      setIsLoading(false);
      errorDispatch(ErrorAction.IngestionError);
    }
  };
  return (
    <Button
      className="button"
      disabled={!formIsValid(fileName, slideNumber, groupName) || loading}
      onClick={handleIngest}
      type="button"
      data-testid="ingest-powerpoint-submit"
    >
      Import
    </Button>
  );
};
